import type { ComponentProps } from "react"
import type { IssueDifficulty as IssueDifficultyValue } from "~/lib/enums"
import { difficultyLabel } from "~/lib/difficulty"
import { useDifficulties } from "~/hooks/useDifficulties"
import { IssuePropertyIcon } from "./IssuePropertyIcon"

export const difficultyConfigs = {
	1: { color: "light-dark(#64748b, #a3adbd)" },
	2: { color: "light-dark(#047857, #6acba2)" },
	3: { color: "light-dark(#a16207, #e8bd62)" },
	4: { color: "light-dark(#c2410c, #f0a16b)" },
	5: { color: "light-dark(#be123c, #f07d96)" }
} satisfies Record<NonNullable<IssueDifficultyValue>, { color: string }>

export function DifficultyIcon({
	difficulty,
	teamId,
	label,
	...props
}: Omit<ComponentProps<"svg">, "color"> & {
	difficulty: IssueDifficultyValue
	withText?: boolean
	teamId?: string | null
	label?: string
}) {
	const difficulties = useDifficulties(teamId)
	const config =
		difficulty === null ? difficultyConfigs[1] : difficultyConfigs[difficulty]
	return (
		<IssuePropertyIcon
			label={label ?? difficultyLabel(difficulty, difficulties)}
			color={config.color}
			{...props}
		>
			{difficulty === null ? (
				<path d="M4 8h8" />
			) : (
				<>
					<path
						d="m8 1.5 6 2.5-6 2.5-6-2.5Z"
						fill="currentColor"
						fillOpacity="0.12"
						opacity={difficulty === 5 ? 1 : 0.16}
					/>
					{[
						"m2 6 6 2.5 6-2.5",
						"m2 8 6 2.5 6-2.5",
						"m2 10 6 2.5 6-2.5",
						"m2 12 6 2.5 6-2.5"
					].map((path, index) => (
						<path
							key={path}
							d={path}
							opacity={index >= 4 - difficulty ? 1 : 0.16}
						/>
					))}
				</>
			)}
		</IssuePropertyIcon>
	)
}
